module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.resourcecenters-ec080a3d9df0ee05d7e6a9ecc89a90d1.svg";